<template>
    <div class="token-item">
        <img class="icon-img" :src="info.icon_url" alt="">
        <div class="item-content">
            <h4 class="title">{{info.symbol}}</h4>
            <p class="desc">{{info.name}}</p>
            <p class="float-right total-supply">{{info.amount}}</p>
        </div>
    </div>
</template>

<script>
import TokenListItem from './TokenListItem';

export default {
    name: 'TokenListItem',
    props: ['info'],
    data () {
        return {
        }
    }
}
</script>

<style scoped lang="less">

    .token-item {
        position: relative;
        padding: 10px;
    }
    .icon-img {
        position: absolute;
        width: 36px;
        height: 36px;
        left: 0;
        top: 15px;
    }
    .item-content {
        margin-left: 50px;
        display: block;

        h4 {
            font-size: 16px;
        }
        .desc {
            font-size: 14px;
        }
    }

    .total-supply {
        position: absolute;
        line-height: 36px;
        right: 0;
        top: 15px;
        font-size: 18px;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/TokenListItem.vue